import { createContext, type PropsWithChildren, useContext } from 'react';

import { type AnalyticsId } from '../../client/AnalyticsProvider/AnalyticsProvider';

type ModalContextType = {
	analyticsId: AnalyticsId;
};

const ModalContext = createContext<ModalContextType | null>(null);

type Props = {
	analyticsId: AnalyticsId;
};

export const ModalProvider = ({ children, analyticsId }: PropsWithChildren<Props>) => {
	return <ModalContext.Provider value={{ analyticsId }}>{children}</ModalContext.Provider>;
};

export const useModalContext = () => {
	const context = useContext(ModalContext);
	if (!context) {
		throw new Error('useModalContext must be used within a ModalProvider');
	}

	return context;
};
